import * as React from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import { ILayoutProps } from './ILayout';
import Header from './Header/Header';
import SaveNotificationSnackbar from './SaveNotificationSnackbar';
import { Container } from '@mui/material';
import './Layout.scss';

const Layout = (props: ILayoutProps) => {
    const location = useLocation(); // Get location object

    // Determine if the current path is related to project info or project type
    const isProjectConfigPath = location.pathname.startsWith('/project-info') || location.pathname.startsWith('/project-type');
    //const isProjectConfigPath = false;

    return (
        <>
            <Header />
            <Container disableGutters={isProjectConfigPath ? false : true} maxWidth={isProjectConfigPath ? 'lg' : false}>
                <main>{props.children}</main>
            </Container>
            <SaveNotificationSnackbar />
        </>
    );
};
export default Layout;
